export default __webpack_public_path__ + "static/media/Corsairs-treasure-14.a0a55710.png";